<template>
  <List :locations="locations"> </List>
</template>

<script>
import locationService from "@/pages/Location/service.js";
import { mapGetters, mapActions } from "vuex";
import List from "@/pages/Location/components/List.vue";
export default {
  data() {
    return {
      locations: []
    };
  },
  components: {
    List
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      return locationService
        .getAll(localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}organizationID`))
        .then(response => {
          console.log("response", response);
          this.locations = response.data;
          return response;
        });
    }
  },
  computed: {
    ...mapGetters("global", ["currentOrganization", "currentUser", "organizationList"])
  }
};
</script>

<style scoped></style>
